import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-report-s-arrow-right",
  "use": "app-icon-report-s-arrow-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-report-s-arrow-right\"><path d=\"M6 4.265v7.47a.593.593 0 00.972.455l4.482-3.735a.593.593 0 000-.91L6.972 3.81A.593.593 0 006 4.265z\" fill=\"#4D4D4D\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol